import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'pcs-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent {
  @Input() value = '';

  @HostBinding('class.active')
  @Input() active = false;
}
